import { createSelector } from 'reselect';

const getDataLoggerCommands = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.loggerCommandsList?.data || [];
};

const getTriggerLoggerCommands = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.loggerCommandsList?.data?.dataLoggerCommands?.triggerLoggerCommands?.commands;
};

const getSpecialLoggerCommands = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.loggerCommandsList?.data?.dataLoggerCommands?.specialLoggerCommands?.commands;
};

const getSubscibeUnsubscribeLoggerCommands = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.loggerCommandsList?.data?.dataLoggerCommands?.subscibeUnsubscribeCommands?.commands;
};

const getDataLoggerCommandsLodingStatus = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.loggerCommandsList?.loadingStatus;
};

const getTriggerLoggerCommandsLoadingStatus = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.triggerLoggerCommands?.loadingStatus;
};

const getSpecialLoggerCommandsLoadingStatus = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.subscribeLoggerCommands?.loadingStatus;
};

const getSubscribeAndUnsubscribeCommandsLoadingStatus = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.subscribeUnsubscribeCommands?.loadingStatus;
};

const getSubscribeWarningTextKey = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.loggerCommandsList?.data?.dataLoggerCommands?.specialLoggerCommands?.warningTextKey;
};
const getSubscribeUnsubscribeWarningTextKey = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.loggerCommandsList?.data?.dataLoggerCommands?.subscibeUnsubscribeCommands?.warningTextKey;
};
const getAmcosWarningTextKey = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.loggerCommandsList?.data?.dataLoggerCommands?.specialLoggerCommands?.warningTextKey;
};

const getLastActivityStatus = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.loggerCommandsList?.data?.dataLoggerCommands?.specialLoggerCommands?.lastActivityStatus;
};

const getCurrentLastActivityStatus = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.subscribeLoggerCommands?.data?.lastActivityStatus;
};
const getSubscribeUnsubscribeLastActivityStatus = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.loggerCommandsList?.data?.dataLoggerCommands?.subscibeUnsubscribeCommands?.lastActivityStatus;
};

const getSubscribeUnsubscribeCurrentLastActivityStatus = ({ dataLoggerCommands }) => {
    return dataLoggerCommands?.subscribeUnsubscribeCommands?.data?.lastActivityStatus;
};

export const getModel = createSelector([
    getDataLoggerCommands,
    getTriggerLoggerCommands,
    getSpecialLoggerCommands,
    getSubscibeUnsubscribeLoggerCommands,
    getDataLoggerCommandsLodingStatus,
    getTriggerLoggerCommandsLoadingStatus,
    getSpecialLoggerCommandsLoadingStatus,
    getSubscribeAndUnsubscribeCommandsLoadingStatus,
    getSubscribeWarningTextKey,
    getSubscribeUnsubscribeWarningTextKey,
    getAmcosWarningTextKey,
    getLastActivityStatus,
    getCurrentLastActivityStatus,
    getSubscribeUnsubscribeLastActivityStatus,
    getSubscribeUnsubscribeCurrentLastActivityStatus
],
    (
        dataLoggerCommands,
        triggerLoggerCommands,
        specialLoggerCommands,
        SubscibeUnsubscribeLoggerCommands,
        dataLoggerCommandsLodingStatus,
        triggerDataLoggerCommandsLoadingStatus,
        specialLoggerCommandsLoadingStatus,
        subscribeAndUnsubscribeCommandsLoadingStatus,
        subscribeWarningTextKey,
        SubscribeUnsubscribeWarningTextKey,
        amcosWarningTextKey,
        lastActivityStatus,
        currentLastActivityStatus,
        subscribeUnsubscribeLastActivityStatus,
        subscribeUnsubscribeCurrentLastActivityStatus
    ) => {
        return {
            dataLoggerCommands,
            triggerLoggerCommands,
            specialLoggerCommands,
            SubscibeUnsubscribeLoggerCommands,
            dataLoggerCommandsLodingStatus,
            triggerDataLoggerCommandsLoadingStatus,
            specialLoggerCommandsLoadingStatus,
            subscribeAndUnsubscribeCommandsLoadingStatus,
            subscribeWarningTextKey,
            SubscribeUnsubscribeWarningTextKey,
            amcosWarningTextKey,
            lastActivityStatus,
            currentLastActivityStatus,
            subscribeUnsubscribeLastActivityStatus,
            subscribeUnsubscribeCurrentLastActivityStatus
        };
    }
);
